import get from 'lodash.get';
import { emptyArray } from '../../../default-props/empty';

export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectSalesOrders = (state) => get(state, 'salesOrders', emptyArray);
export const selectFulfillmentPlans = (state) => get(state, 'fulfillmentPlans', emptyArray);
export const selectTotalCount = (state) => get(state, 'totalCount');
